import { PageEvents } from '@griply/types';
import { Suspense } from 'react';
import * as React from 'react';
import { useLoaderData } from 'react-router-dom';
import { LoginLoaderData } from 'shared/routes/loaders';
import { getSupportsBrowserSignIn } from 'shared/utils/get-supports-browser-sign-in';
import { DesktopSignIn } from 'shared/views/desktop-sign-in';

import { LoginView } from './components/login-view';

export const Login: React.FC = () => {
  const { hasDesktopSignInFailed } = useLoaderData() as LoginLoaderData;

  if (getSupportsBrowserSignIn()) {
    return (
      <DesktopSignIn
        pageEvent={PageEvents.Login}
        hasFailed={hasDesktopSignInFailed}
      />
    );
  }

  return (
    <Suspense>
      <LoginView />
    </Suspense>
  );
};
